export enum ResidencyType {
  Resident = "Resident",
  Visa = "Visa",
}
